<template>
  <div>
    <!-- heading starts -->
    <transition
      tag="div"
      mode="out-in"
      enter-active-class="animate__animated animate__zoomIn"
      leave-active-class="animate__animated animate__zoomOut"
    >
      <div v-if="isShow" key="hi">
        <v-row>
          <v-col class="mb-3 custom-sheet">
            <v-sheet rounded elevation="3" v-if="this.role === 'user'">
              <div class="premium pt-2">
                <img src="/img/NBA/premium.svg" height="35" width="35" />
                <span class="ma-1 body font-weight-medium"> Top Plays </span>

                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="float-right"
                        text
                        icon
                        color="primary"
                        @click="closeButton"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="#FF5252">mdi-close-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Close</span>
                  </v-tooltip>
                </div>
              </div>

              <v-skeleton-loader
                v-show="topPlayersLoader"
                :loading="topPlayersLoader"
                class="pa-1"
                type="text, chip"
                elevation="2"
              />

              <v-col cols="12" md="12" sm="12" v-show="!topPlayersLoader">
                <v-chip-group multiple class="pt-3 my-n2 mt-md-n6 mt-1">
                  <v-chip
                    v-for="filter in premiumFilterList.data"
                    :color="
                      filter.isActive ? 'green accent-2' : 'blue-grey lighten-4'
                    "
                    :key="filter._id"
                    class="ma-2"
                    :disabled="filter.status === 0"
                    v-model="filter.isActive"
                    large
                    @change="getTopPlayers(slateId, filter)"
                  >
                    <v-avatar left class="blue lighten-4">
                      <v-icon>mdi-account-circle-outline</v-icon>
                    </v-avatar>
                    {{ filter.userName }}

                    <v-avatar v-show="filter.isActive == true" right>
                      <v-icon
                        color="warning"
                        @click="hideTopPlayers(slateId, filter._id)"
                        >mdi-close-circle-outline</v-icon
                      >
                    </v-avatar>
                  </v-chip>
                </v-chip-group>
              </v-col>

              <!-- <v-col cols="12" md="2" sm="12" align-self="center">
                    <v-btn
                      class="float-right"
                      small
                      color="red lighten-1"
                      @click="resetPremiumFilter"
                    >
                      Reset Filters
                    </v-btn>
                  </v-col> -->
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </transition>

    <div key="bye">
      <!-- controler row -->
      <v-col
        cols="12"
        md="12"
        sm="12"
        class="optimizer-panel optimizerpanelnew mb-n3"
      >
        <!-- //*optimizer controller -->
        <div class="py-2 py-md-0 mt-2 no-padding-margin">
          <v-sheet elevation="2" rounded>
            <v-col cols="12" md="12" sm="12" class="py-0 py-sm-5 py-md-5">
              <!-- //? controllers -->
              <v-row class="slate-selector mobile-d-none">
                <!--//! Radio buttons -->
                <v-col
                  cols="6"
                  md="3"
                  sm="5"
                  class="mx-auto ml-md-1 mt-md-n4 mt-n2 cus-radio-bnt"
                  align="center"
                >
                  <v-radio-group v-model="radio" row>
                    <v-radio
                      label="Classic"
                      value="classic"
                      color="green"
                      @change="onlyClassic()"
                    ></v-radio>
                    <v-radio
                      label="Single Game"
                      color="green"
                      value="others"
                      @change="otherThanClassic()"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <!--//! Radio buttons ends -->

                <v-spacer></v-spacer>

                <!--//! Selector starts -->
                <v-row justify="center" align="center">
                  <v-col
                    cols="6"
                    md="3"
                    sm="3"
                    class="caption cus-caption-6 mt-n1 text-end ml-4 ml-sm-0 ml-md-0"
                  >
                    <p class="font-weight-bold">Slate Time NHL:</p>
                  </v-col>
                  <v-col cols="6" md="4" sm="3" class="ml-n5 mt-n1">
                    <v-select
                      light
                      :items="Slates"
                      item-text="OperatorName"
                      item-value="SlateID"
                      v-model="slateId"
                      dense
                      outlined
                      @change="fetchPlayers"
                    >
                      <template v-slot:item="{ item }">
                        <small class="caption">
                          {{ item.OperatorName }}&nbsp;
                          {{ item.OperatorStartTime | timeFormat }}
                          ({{ item.NumberOfGames }}games)
                        </small>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <!--//! Selector ends -->

                <v-spacer></v-spacer>

                <!--//* show/hide 0 proj. -->
                <v-row justify="center" class="mx-0 class-five">
                  <v-col
                    cols="4"
                    md="4"
                    sm="8"
                    class="mt-md-3 mt-sm-3 mt-n8 mb-3 px-1"
                  >
                    <div
                      class="show-projection-button"
                      v-if="isShowProjection"
                      @click="showProjection"
                    >
                      <a class="white--text caption a-text font-weight-bold"
                        >Show 0 proj.</a
                      >
                    </div>

                    <div
                      class="hide-projection-button"
                      v-if="isHideProjection"
                      @click="hideProjection"
                    >
                      <a
                        class="white--text caption a-text-hide font-weight-bold"
                        >Hide 0 proj.</a
                      >
                    </div>
                  </v-col>

                  <!-- reset button -->
                  <v-col
                    cols="3"
                    md="4"
                    sm="4"
                    @click="resetPlayer"
                    class="mb-3 mt-md-3 mt-sm-3 mt-n8 px-1"
                  >
                    <div class="reset-button">
                      <a
                        class="white--text caption a-text-hide font-weight-bold"
                        >Reset</a
                      >
                    </div>
                  </v-col>
                  <!-- reset button -->

                  <!-- Import -->
                  <div class="mt-6" align-self="start">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          @click="openUploadModal"
                          depressed
                          :color="planType !== 'Free' ? 'blue' : '#B0BEC5'"
                          style="height: 30px; min-width: 15px"
                        >
                          <v-icon color="white" size="20">
                            mdi-cloud-download-outline</v-icon
                          >
                        </v-btn>
                      </template>
                      <span class="caption">Import Projection</span>
                    </v-tooltip>

                    <!-- dialog -->
                    <v-dialog
                      transition="dialog-top-transition"
                      v-model="UploadDialog"
                      max-width="500"
                    >
                      <template v-slot:default="UploadDialog">
                        <upload-projection
                          @import="importCsv"
                          :title="'Upload Custom Projections'"
                        />
                      </template>
                    </v-dialog>
                    <!-- dialog-->
                  </div>
                  <!-- Import ends.. -->

                  <!-- Export -->
                  <div class="mt-6 mx-1" align-self="start">
                    <download-csv
                      :data="this.JsonFormat"
                      :name="`Projection_${slateId}_${operator}_nhl.csv`"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            @click="exportCsv"
                            depressed
                            :color="planType !== 'Free' ? 'blue' : '#B0BEC5'"
                            style="height: 30px; min-width: 15px"
                          >
                            <v-icon color="white" size="20">
                              mdi-cloud-upload-outline</v-icon
                            >
                          </v-btn>
                        </template>
                        <span class="caption">Export Projection</span>
                      </v-tooltip>
                    </download-csv>
                  </div>
                  <!-- Export ends.. -->
                </v-row>
                <!--//* show/hide 0 proj. ends -->
              </v-row>
              <!-- //? controllers ends... -->

              <!-- only for mobile strat here -->
              <v-row class="slate-selector d-block d-md-none">
                <!--//! Radio buttons -->
                <v-col
                  cols="5"
                  md="4"
                  sm="5"
                  class="mx-auto ml-md-1 mt-md-n4 mt-n2 cus-radio-bnt float-left"
                  align="center"
                >
                  <v-radio-group v-model="radio" row>
                    <v-radio
                      label="Classic"
                      value="classic"
                      color="green"
                      @change="onlyClassic()"
                    ></v-radio>
                    <v-radio
                      label="Single Game"
                      value="others"
                      color="green"
                      @change="otherThanClassic()"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <!--//! Radio buttons ends -->

                <!--//! Selector starts -->
                <v-col cols="7" class="float-right cus-caption-6">
                  <!-- row 1... -->
                  <v-row class="slate-selector cus-slate-time">
                    <v-col cols="6" class="caption">
                      <strong>Slate Time NHL:</strong>
                    </v-col>

                    <v-col cols="6">
                      <!--//* show/hide 0 proj. -->
                      <div
                        class="show-projection-button"
                        v-if="isShowProjection"
                      >
                        <a
                          class="white--text caption a-text font-weight-bold"
                          @click="showProjection"
                          >Show 0 proj.</a
                        >
                      </div>

                      <div
                        class="hide-projection-button"
                        v-if="isHideProjection"
                      >
                        <a
                          class="white--text caption a-text-hide font-weight-bold"
                          @click="hideProjection"
                          >Hide 0 proj.</a
                        >
                      </div>
                    </v-col>
                  </v-row>

                  <!-- row 2... -->
                  <v-row class="slate-selector">
                    <v-col cols="6" md="3" sm="3" class="mt-n4">
                      <v-select
                        light
                        :items="Slates"
                        item-text="OperatorName"
                        item-value="SlateID"
                        v-model="slateId"
                        dense
                        outlined
                        @change="fetchPlayers"
                      >
                        <template v-slot:item="{ item }">
                          <small class="caption">
                            {{ item.OperatorName }}&nbsp;
                            {{ item.OperatorStartTime | timeFormat }}
                            ({{ item.NumberOfGames }}games)
                          </small>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col col="6">
                      <!-- reset button -->
                      <div class="reset-button">
                        <a
                          class="white--text caption a-text-hide font-weight-bold"
                          @click="resetPlayer"
                        >
                          Reset
                        </a>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <!--//! Selector ends -->
              </v-row>
              <!-- only for mobile end here -->

              <v-divider class="pb-4 mt-2 mt-md-n6 mt-sm-n6"></v-divider>

              <v-row
                no-gutters
                class="filter-button-group cus-filter"
                align="center"
              >
                <!--//* team stack -->
                <v-col cols="3" md="1" sm="2" class="class-one">
                  <v-badge
                    :value="playerPerTeam"
                    color="green"
                    bordered
                    overlap
                    left
                    class="mt-md-1 mx-md-0 ml-sm-6 ml-1 mx-auto cus-team-stack"
                  >
                    <v-btn
                      small
                      depressed
                      class="pa-md-4 pa-2 white--text team-stack-btn"
                      :color="planType !== 'Free' ? '#171515' : '#B0BEC5'"
                      @click="goToTeamStack"
                    >
                      Team Stack
                    </v-btn>
                  </v-badge>
                </v-col>
                <!--//* team stack ends-->

                <!--//* top plays user-->
                <v-col
                  cols="3"
                  md="1"
                  sm="3"
                  class="class-two ma-2"
                  v-if="this.role === 'user'"
                >
                  <v-btn
                    class="mt-md-1 mx-md-n2 ml-sm-6 ml-6 mx-auto pa-sm-0 pa-md-4 cus-top-player white--text"
                    small
                    depressed
                    :color="disableButton"
                    @click="showPremiumList"
                  >
                    Top Plays
                  </v-btn>
                </v-col>
                <!--//* top plays ends-->

                <div class="mx-3"></div>
                <!--//* top plays client -->
                <v-col
                  cols="3"
                  md="1"
                  sm="3"
                  class="class-two"
                  v-if="this.role === 'client'"
                >
                  <v-btn
                    class="mt-md-1 mx-md-n2 ml-sm-6 ml-4 mx-auto pa-sm-0 pa-md-4 cus-Optimize-pool white--text"
                    small
                    depressed
                    color="#171515"
                    :to="{
                      name: 'nhlTopPlaysClient',
                      params: { role: this.role },
                    }"
                  >
                    Top Plays
                  </v-btn>
                </v-col>
                <!--//* top plays ends-->

                <!-- //? build team button for mobile view only-->
                <v-col
                  cols="4"
                  md="1"
                  sm="3"
                  v-if="$vuetify.breakpoint.smAndDown"
                  class="d-flex flex-row align-center ml-2"
                >
                  <v-btn
                    v-if="isOptiShow"
                    class="mt-md-1 mx-md-n2 ml-sm-6 ml-3 mx-auto py-0 px-2 py-md-4 px-md-4 cus-Optimize-pool"
                    small
                    depressed
                    color="success"
                    @click="HideOptiTable"
                  >
                    Build Teams
                  </v-btn>

                  <v-btn
                    v-if="isOptiHide"
                    class="mt-md-1 mx-md-n2 ml-sm-6 ml-3 mx-auto pa-4 white--text py-0 px-2 py-md-4 px-md-4 cus-Optimize-pool"
                    small
                    depressed
                    color="#26C6DA"
                    @click="ShowOptiTable"
                  >
                    Player Pool
                  </v-btn>

                  <!-- menu for upload projection... -->
                  <div class="d-flex flex-row">
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn fab icon v-bind="attrs" v-on="on">
                          <v-icon color="green">mdi-cloud</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item>
                          <div align-self="start">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  @click="openUploadModal"
                                  depressed
                                  :color="
                                    planType !== 'Free' ? 'blue' : '#B0BEC5'
                                  "
                                  style="height: 30px; min-width: 15px"
                                >
                                  <v-icon color="white" size="20">
                                    mdi-cloud-download-outline</v-icon
                                  >
                                </v-btn>
                              </template>
                              <span class="caption">Import Projection</span>
                            </v-tooltip>
                          </div>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <div align-self="start">
                            <download-csv
                              :data="this.JsonFormat"
                              :name="`Projection_${slateId}_${operator}_nhl.csv`"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    @click="exportCsv"
                                    depressed
                                    :color="
                                      planType !== 'Free' ? 'blue' : '#B0BEC5'
                                    "
                                    style="height: 30px; min-width: 15px"
                                  >
                                    <v-icon color="white" size="20">
                                      mdi-cloud-upload-outline</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span class="caption">Export Projection</span>
                              </v-tooltip>
                            </download-csv>
                          </div>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <!-- menu for upload projection... -->

                  <!-- dialog -->
                  <v-dialog
                    transition="dialog-top-transition"
                    v-model="UploadDialog"
                    max-width="500"
                  >
                    <template v-slot:default="UploadDialog">
                      <upload-projection
                        @import="importCsv"
                        :title="'Upload Custom Projections'"
                      />
                    </template>
                  </v-dialog>
                  <!-- dialog -->
                </v-col>
                <!--//? build team button for mobile view only end... -->

                <!-- filter starts -->
                <v-row
                  class="class-three"
                  v-show="isFilterHidden"
                  justify="end"
                >
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="9" sm="12" class="parent-col">
                    <v-col
                      cols="12"
                      class="mt-1 ml-4 no-space"
                      align-self="center"
                      md="12"
                      sm="12"
                      v-if="
                        operator == 'DraftKings' &&
                        operatorGameType == 'Classic'
                      "
                    >
                      <v-chip-group
                        v-model="selectionD"
                        active-class="light-green darken-3 white--text"
                        class="mx-auto chip-selector"
                        center-active
                        @change="getFilterByPosition(selectionD)"
                        mandatory
                      >
                        <v-chip
                          v-for="selectionD in positionD"
                          :key="selectionD"
                          :value="selectionD"
                        >
                          {{ selectionD }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>

                    <v-col
                      cols="12"
                      class="mt-1 no-space"
                      md="12"
                      sm="12"
                      v-if="
                        operator == 'DraftKings' && operatorGameType == 'Single'
                      "
                    >
                      <v-chip-group
                        v-model="selectionDS"
                        active-class="light-green darken-3 white--text"
                        class="ml-3 chip-selector"
                        center-active
                        @change="getFilterBySingle(selectionDS)"
                        mandatory
                      >
                        <v-chip
                          v-for="selectionDS in positionDS"
                          :key="selectionDS"
                          :value="selectionDS"
                        >
                          {{ selectionDS }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>

                    <!-- //? Fandeul -->
                    <v-col
                      cols="12"
                      class="mx-auto mt-1 no-space"
                      md="8"
                      sm="12"
                      v-if="
                        operator == 'FanDuel' && operatorGameType == 'Classic'
                      "
                    >
                      <v-chip-group
                        v-model="selectionF"
                        active-class="light-green darken-3 white--text"
                        class="ml-3 chip-selector"
                        center-active
                        @change="getFilterByPosition(selectionF)"
                        mandatory
                      >
                        <v-chip
                          v-for="selectionF in positionF"
                          :key="selectionF"
                          :value="selectionF"
                        >
                          {{ selectionF }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>

                    <v-col
                      cols="12"
                      class="mx-auto mt-1 no-space"
                      md="8"
                      sm="12"
                      v-if="
                        operator == 'FanDuel' && operatorGameType == 'Single'
                      "
                    >
                      <v-chip-group
                        v-model="selectionFS"
                        active-class="light-green darken-3 white--text"
                        class="ml-3 chip-selector"
                        center-active
                        @change="getFilterByPositionInFanduel(selectionFS)"
                        mandatory
                      >
                        <v-chip
                          v-for="selectionFS in positionFS"
                          :key="selectionFS"
                          :value="selectionFS"
                        >
                          {{ selectionFS }}
                        </v-chip>
                        <!-- <v-chip></v-chip> -->
                      </v-chip-group>
                    </v-col>
                  </v-col>
                </v-row>
                <!-- filter ends -->

                <!--//? build team controls only desktop-->
                <v-row
                  class="mt-n1 mx-0 class-four"
                  align-content="space-between"
                  justify="end"
                  v-if="
                    !$vuetify.breakpoint.smOnly && !$vuetify.breakpoint.xsOnly
                  "
                >
                  <!-- heading starts -->

                  <!--//* build input -->
                  <v-col
                    cols="3"
                    md="4"
                    sm="3"
                    class="mb-5 mb-md-5 mb-sm-5 ml-2 ml-md-0 ml-sm-0 pa-4"
                    align-self="center"
                  >
                    <v-text-field
                      class="maximum float-right mr-md-n8"
                      solo
                      dense
                      placeholder="20"
                      :disabled="planType === 'Free' ? true : false"
                      :rules="maxRule"
                      v-model="NumberOfBuild"
                    />
                  </v-col>

                  <!--//* build button -->
                  <v-col
                    cols="3"
                    md="4"
                    sm="3"
                    v-if="NumberOfBuild > 150"
                    align-self="center"
                  >
                    <v-btn
                      class="btn-help-video ml-n3 ml-md-3 ml-sm-n3 pa-4"
                      small
                      disabled
                      color="info"
                    >
                      Build Teams
                    </v-btn>
                  </v-col>

                  <v-col cols="3" md="4" sm="3" v-else align-self="center">
                    <v-btn
                      class="btn-help-video ml-n3 ml-md-3 ml-sm-n3 white--text pa-4"
                      small
                      color="success"
                      @click="refBuildTeam"
                    >
                      Build Teams
                    </v-btn>
                  </v-col>

                  <v-col md="1" align-self="center">
                    <v-btn
                      @click="showBuildTeam"
                      class="float-right"
                      icon
                      color="blue"
                    >
                      <v-icon v-if="!toggleBuildVisibility" size="30">
                        mdi-arrow-left-drop-circle-outline</v-icon
                      >
                      <v-icon v-else size="30">
                        mdi-arrow-right-drop-circle-outline</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-row>
                <!--//? build team controls ends-->
              </v-row>
              <!-- //* controllers ends..-->
            </v-col>
          </v-sheet>
        </div>
        <!-- //*optimizer controller ends-->
      </v-col>
      <!-- controler row ends-->

      <v-row no-gutters class="mx-1">
        <v-col
          cols="12"
          :md="toggleBuildVisibility ? 7 : 12"
          sm="12"
          class="optimizer-panel"
        >
          <!--//* Position optimizer table -->
          <div class="mt-2 team-stack-table" v-show="IsOptiTable">
            <v-skeleton-loader
              height="900"
              v-show="loadingStatus"
              :loading="loadingStatus"
              class="mb-3"
              type="list-item-avatar-two-line,table@2"
              elevation="2"
            >
            </v-skeleton-loader>
            <nhl-optimizer-table
              v-show="!loadingStatus"
              :playerDetails="this.playersDetail"
              :selectionD="selectionD"
              :selectionDS="selectionDS"
              :selectionF="selectionF"
              :selectionFS="selectionFS"
              :slates="Slates"
              :slateID="slateId"
              :defaultSport="defaultSport"
              :defaultOptimizer="defaultOptimizer"
              :defaultGameType="operatorGameType"
            />
          </div>
          <!--//* Position optimizer table ends -->

          <!--//* Build Exposure table -->
          <build-exposure
            v-show="isBuildExposure"
            :allSlate="allSlate"
            :defaultOptimizer="defaultOptimizer"
            :defaultSport="defaultSport"
            @hideExposureBuild="hideExposureBuild"
          />
          <!--//* Build Exposure table ends -->
        </v-col>

        <v-col class="build-team tablenewdesign" cols="12" md="5" sm="12">
          <transition
            mode="out-in"
            enter-active-class="animate__animated animate__fadeIn  animate__faster"
            leave-active-class="animate__animated animate__fadeOut  animate__faster"
          >
            <div class="mt-3 mx-2">
              <!--//* build team -->
              <v-skeleton-loader
                height="950"
                v-show="buildTeamLoader"
                :loading="buildTeamLoader"
                class="mb-3 mt-4"
                type="list-item-avatar-two-line,table@2"
                elevation="2"
              >
              </v-skeleton-loader>

              <transition
                mode="out-in"
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated animate__fadeOut animate__faster"
              >
                <div v-show="toggleBuildVisibility">
                  <build-teams
                    v-show="!buildTeamLoader"
                    :slateId="this.slateId"
                    :operator="this.operator"
                    :operatorGameType="this.operatorGameType"
                    :sportType="sportType"
                    :sportId="sportId"
                    :defaultSport="defaultSport"
                    :defaultOptimizer="operator"
                    :playerSwap="playerSwap"
                    :numberOFGames="numberOfGames.NumberOfGames"
                    :NumberOfBuildDesktop="NumberOfBuild"
                    @buildExposure="fetchBuildExposureNhl"
                    ref="teamBuild"
                  />
                </div>
              </transition>
            </div>
          </transition>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import common from "../../../services/common.js";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import { showPlayers } from "@/mixins/showPlayers.js";

const UploadProjection = () =>
  import("@/components/Modal/UploadProjection.vue");

// import BuildTeams from '@/components/Tables/BuildTeams.vue';
const BuildTeams = () => import("@/components/Tables/BuildTeams.vue");

const UpgradePlanModal = () =>
  import("@/components/Modal/UpgradePlanModal.vue");

// import NflOptimizerTable from '@/components/Tables/NflOptimizerTable.vue';
const NhlOptimizerTable = () =>
  import("@/components/Tables/NhlOptimizerTable.vue");

import BuildExposure from "../../BuildExposure.vue";

export default {
  name: "NhlPositionOpti",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],
  mixins: [showPlayers],

  components: {
    BuildTeams,
    NhlOptimizerTable,
    UploadProjection,
    UpgradePlanModal,
    BuildExposure,
  },

  data() {
    return {
      // team_build: [],
      // componentKey: 0,
      planType: this.$store.state.userModule.userState.plantype,
      isShow: false,
      UploadDialog: false,
      UpgradeModal: false,
      JsonFormat: [],
      selectedFile: null,
      isFilterHidden: true,
      toggleBuildVisibility: false,
      isShowProjection: true,
      isHideProjection: false,
      isOptiShow: true,
      isOptiHide: false,
      IsOptiTable: true,
      isBuildExposure: false,
      newTopPlayers: [],
      radio: "others",
      Slates: [],
      operator: "",
      operatorGameType: "",
      sportType: "",
      sportId: "",
      slateId: "",
      userId: localStorage.getItem("user"),
      role: localStorage.getItem("role"),
      isBanner: JSON.parse(localStorage.getItem("isBanner")),
      positionD: ["C", "W", "D", "G", "FLEX", "Lck/Exl"],
      positionF: ["C", "W", "D", "G", "Lck/Exl"],
      positionDS: ["CPT", "FLEX", "Lck/Exl"],
      positionFS: ["MVP", "FLEX", "Lck/Exl"],
      selectionD: "C",
      selectionDS: "CPT",
      selectionF: "C",
      selectionFS: "MVP",
      numberOfGames: {},
      maxRule: [(v) => (v >= 0 && v <= 150) || "Max Limit: 150"],
      NumberOfBuild:
        this.$store.state.userModule.userState.plantype === "Free" ? 3 : 10,
    };
  },

  computed: {
    ...mapGetters("NhlModule", [
      "loadingStatus",
      "getFilterByPosition",
      "getFilterBySingle",
      "getFilterByPositionInFanduel",
      "buildTeamLoader",
      "topPlayersLoader",
    ]),
    ...mapState("NhlModule", [
      "playersDetail",
      "playerPerTeam",
      "premiumFilterList",
      "topPlayers",
      "playerSwap",
    ]),

    disableButton() {
      if (this.planType) {
        if (this.planType === "Free" || this.planType === "Premium") {
          return "#B0BEC5";
        } else {
          return "#171515";
        }
      }
    },
  },

  methods: {
    showBuildTeam() {
      if (!this.toggleBuildVisibility) {
        this.toggleBuildVisibility = true;
        this.fetchLastLineup();
      } else {
        this.toggleBuildVisibility = false;
      }
    },

    openUploadModal() {
      if (this.planType === "Free") {
        this.UpgradeModal = true;
      } else {
        this.UploadDialog = true;
      }
    },

    fetchBuildExposureNhl(values) {
      this.$store.dispatch("userModule/setBuildExposure", values).then(() => {
        this.isBuildExposure = true;
        this.IsOptiTable = false;
      });
    },

    hideExposureBuild() {
      this.isBuildExposure = false;
      this.IsOptiTable = true;
    },

    importCsv(file) {
      console.log(file);
      let data = new FormData();
      data.append("file", file[0], file.name);
      data.append("user", this.userId);
      data.append("SlateID", this.slateId);
      this.$store.dispatch("userModule/submitCsvProjection", data).then(() => {
        this.fetchPlayers();
        this.UploadDialog = false;
      });
    },

    exportCsv() {
      this.JsonFormat = [];
      if (this.planType === "Free") {
        this.UpgradeModal = true;
      } else {
        // export csv...
        if (this.playersDetail.length === 0) {
          alert("Please let the players list loading first.");
        } else {
          this.JsonFormat = this.playersDetail.map((_player) => {
            let newObj = {
              name: _player.Name,
              team: _player.Team,
              pos:
                this.operator === "DraftKings"
                  ? _player.DraftKingsPosition
                  : _player.FanDuelPosition,
              player_id: _player.PlayerID,
              proj_points:
                this.operator === "DraftKings"
                  ? _player.DraftKingsProjection
                  : _player.FandDualProjection,
              salary:
                this.operator === "DraftKings"
                  ? _player.DraftKingsSalary
                  : _player.FanDuelSalary,
            };

            return newObj;
          });
        }
      }
    },

    refBuildTeam() {
      this.toggleBuildVisibility = true;
      this.$refs.teamBuild.checkTodayLineup(true);
    },

    hideBuildPanel() {
      this.toggleBuildVisibility = false;
    },

    HideOptiTable() {
      this.isOptiHide = true;
      this.isOptiShow = false;
      this.IsOptiTable = false;
      this.isFilterHidden = false;
      this.toggleBuildVisibility = true;
      this.$refs.teamBuild.checkTodayLineup(true);
    },

    ShowOptiTable() {
      this.isOptiShow = true;
      this.isOptiHide = false;
      this.IsOptiTable = true;
      this.isFilterHidden = true;
      this.toggleBuildVisibility = false;
    },

    onDismiss() {
      let obj = {
        isBanner: false,
        userId: this.userId,
      };
      common.BannerStatus(obj);
      localStorage.removeItem("isBanner");
      localStorage.setItem("isBanner", false);
    },

    closeButton() {
      this.isShow = false;

      let obj = {
        user: this.userId,
        operator: this.operator,
        gametype: this.operatorGameType,
        SlateID: this.slateId,
        projectiontype: 1,
      };
      this.$store.dispatch("NhlModule/getPlayer", obj);
    },

    showPremiumList() {
      if (this.planType === "Free" || this.planType === "Premium") {
        this.UpgradeModal = true;
      } else {
        let payload = {
          slatId: this.slateId,
        };

        this.isShow = !this.isShow;
        if (this.isShow == true) {
          this.$store.dispatch("NhlModule/GetPremiumFilterList", payload);
        } else {
          let obj = {
            user: this.userId,
            operator: this.operator,
            gametype: this.operatorGameType,
            SlateID: this.slateId,
          };
          this.$store.dispatch("NhlModule/getPlayer", obj);
        }
      }
    },

    hideTopPlayers(slateId, clientId) {
      let self = this;

      this.newTopPlayers = [];
      let payload = {
        clientid: clientId,
        slatId: slateId,
      };

      this.$store.dispatch("NhlModule/GetTopPlays", payload).then(() => {
        //console.log('top players', this.topPlayers.data);
        let newArry = _.differenceBy(
          this.$store.state.NhlModule.playersDetail,
          this.topPlayers.data,
          "SlatePlayerID"
        );
        this.$store.state.NhlModule.playersDetail = newArry;
        // //console.log('newArry', this.$store.state.NhlModule.playersDetail);

        let filterStatus = _.find(
          this.$store.state.NhlModule.premiumFilterList.data,
          ["isActive", true]
        );
        // //console.log('filterStatus', filterStatus);

        if (filterStatus == undefined) {
          let obj = {
            user: self.userId,
            operator: self.operator,
            gametype: self.operatorGameType,
            SlateID: self.slateId,
          };
          self.$store.dispatch("NhlModule/getPlayer", obj);
        }
      });
    },

    getTopPlayers(slateId, filter) {
      let payload = {
        clientid: filter._id,
        slatId: slateId,
      };

      if (!filter.isActive) {
        this.$store.dispatch("NhlModule/GetTopPlays", payload).then(() => {
          this.newTopPlayers.push(...this.topPlayers.data);

          this.$store.state.NhlModule.playersDetail = _.uniqBy(
            this.newTopPlayers,
            "SlatePlayerID"
          );
          // console.log(
          //   'playerDetail',
          //   this.$store.state.NhlModule.playersDetail
          // );
        });
      } else {
        this.hideTopPlayers(payload.slatId, payload.clientid);
      }
    },

    showProjection() {
      let obj = {
        user: this.userId,
        operator: this.operator,
        gametype: this.operatorGameType,
        SlateID: this.slateId,
        projectiontype: 0,
      };
      this.$store.dispatch("NhlModule/getPlayer", obj).then(() => {
        this.isShowProjection = false;
        this.isHideProjection = true;
      });
    },

    hideProjection() {
      let obj = {
        user: this.userId,
        operator: this.operator,
        gametype: this.operatorGameType,
        SlateID: this.slateId,
        projectiontype: 1,
      };
      this.$store.dispatch("NhlModule/getPlayer", obj).then(() => {
        this.isHideProjection = false;
        this.isShowProjection = true;
      });
    },

    goToTeamStack() {
      if (this.planType === "Free") {
        this.UpgradeModal = true;
      } else {
        this.$router.push({
          name: "nhlTeamStack",
          params: {
            slateId: this.slateId,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.v-chip-group >>> .v-slide-group__content {
  padding: 4px 0;
  display: flex;
  justify-content: center;
}

.premium {
  display: flex;
  justify-content: center;
}

.maximum {
  font-size: 0.8em;
  min-height: 2px;
  max-width: 130px;
  max-height: 20px;
}
.show-projection-button {
  border-radius: 5px;
  box-shadow: 0px 1px 7px -3px;
  border: 1px solid transparent;
  text-align: center;
  padding: 1px;
  background-color: #62f1aa;
  cursor: pointer;
}

.hide-projection-button {
  border-radius: 5px;
  box-shadow: 0px 1px 7px -3px;
  border: 1px solid transparent;
  text-align: center;
  padding: 1px;
  background-color: #2ff3e3;
  cursor: pointer;
}
.reset-button {
  border-radius: 5px;
  box-shadow: 0px 1px 7px -3px;
  border: 1px solid transparent;
  text-align: center;
  padding: 2px;
  background-color: #f52f2f;
  cursor: pointer;
}

.a-text:hover {
  text-shadow: 5px 1px 5px rgba(178, 239, 57, 1);
}

.a-text-hide:hover {
  text-shadow: 5px 1px 5px rgba(65, 233, 252, 1);
}

.chip-selector >>> .v-chip.v-size--default {
  border-radius: 8px;
}

/* .class-five {
    margin-left: 30%;
  } */
</style>
